import {ReactElement, useEffect} from "react";
import {LayoutSwitcher, SystemMessage} from "../../components/layout";
import {getLogger, getPublicRuntimeConfig} from "../../util";

const publicRuntimeConfig = getPublicRuntimeConfig();
const logger = getLogger("AppDeeplinkError");

/**
 * Rendered when we detect the user is on the device but somehow because of broken
 * deep links has landed on the web version of the app after auth.
 * This informs the user they are on the web version and the steps they need to take to return to the app.
 * @constructor
 */
export const AppDeeplinkError = (): ReactElement => {
    const projectName = publicRuntimeConfig.siteName;

    useEffect(() => {
        logger.log("Rendered app deeplink page", {
            url: window.location.href,
            userAgent: navigator.userAgent,
        });
    }, []);

    return (
        <LayoutSwitcher
            showAuth={false}
            showBackButton={false}
            showMenu={false}
            showEventSelector={false}
            showNewActionButton={false}
            showLoadingIndicator={false}
            showSiteSelector={false}
            showFooter={false}
            showHeader={false}
            showSimpleLayout={true}
        >
            <div style={{
                display: "flex",
                flexDirection: "column",
                margin: "1rem",
            }}
            >
                <h1>Launching {projectName}.</h1>

                <SystemMessage type="warning">
                    You have signed in and are now being redirecting to the {projectName} app...
                </SystemMessage>

                <p>
                    Not working? Close this browser tab and open your {projectName} app and try again.
                </p>

                <p>
                    If you still have problems, try restarting your device or re-installing the app.
                </p>
            </div>
        </LayoutSwitcher>
    );
};
